/**
 * BaseUrl: empty string means same-origin (nginx proxies /postmessage, /api to the Node app).
 * REACT_APP_PUBLIC_URL must be set in CI to "" (empty) or omitted — never leave it unset in code
 * without defaulting, or URLs become "undefined/postmessage" and the landing breaks.
 */
const rawPublic = process.env.REACT_APP_PUBLIC_URL;
const BaseUrl =
  rawPublic === undefined || rawPublic === null || rawPublic === ''
    ? ''
    : String(rawPublic).replace(/\/$/, '');

const KeyRecaptcha = process.env.REACT_APP_KEY_RECAPTCHA || '';

/** Ized org in DB — contact form posts to this tenant */
const OrganizationId =
  process.env.REACT_APP_ORGANIZATION_ID || '677bc0da1890e1e7d024e878';

export { BaseUrl, KeyRecaptcha, OrganizationId };
